import axios from 'axios'
import { ElMessage } from 'element-plus'

const service = axios.create({
    baseURL: '/codex',
    timeout: 60000
})

service.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    const userId = localStorage.getItem('userId')
    if (token) {
        config.headers.Authorization = token
    }
    if (userId) {
        config.headers['X-User-Id'] = userId
    }
    return config
}, err => Promise.reject(err))

service.interceptors.response.use(res => {
    return res.data
}, err => {
    if (err.response && err.response.status === 401) {
        localStorage.removeItem('token')
        localStorage.removeItem('userId')
        localStorage.removeItem('role')
        window.location.href = '/login'
    }
    ElMessage.error('网络请求失败')
    return Promise.reject(err)
})

export default service
